import React, { useContext } from 'react'
import MuiPhoneInput from 'material-ui-phone-number-2'
import CustomCommonContext from '../../../../custom/context/common/commonContext'
import TextField from '@mui/material/TextField'
import { InputAdornment, IconButton } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'

const formatPhoneLocal = (value) => {
    const digits = value.replace(/\D/g, '').slice(0, 8)
    if (digits.length <= 2) return digits
    if (digits.length <= 5) return `${digits.slice(0, 2)} ${digits.slice(2)}`
    return `${digits.slice(0, 2)} ${digits.slice(2, 5)} ${digits.slice(5)}`
}

const CustomPhone = (props) => {
    const customCommonContext = useContext(CustomCommonContext)
    const { allConfigurationVariables } = customCommonContext

    const shrink = props.shrink ? props.shrink.toString() : 'false'

    const handleChange = (value) => {
        // Get the div element by using a ref

        if (props.onError) {
            const divElement = document.querySelector(
                `.MuiInputBase-root.Mui-error input[name="${props.name}"]`
            )

            // Check if the "Mui-error" class is present
            let isError = false
            if (divElement) {
                if (divElement.parentNode.classList.contains('Mui-error')) {
                    if (props.minChar && props.maxChar) {
                        if (
                            value.length > props.minChar &&
                            value.length < props.maxChar
                        ) {
                            isError = true
                        } else {
                            isError = false
                        }
                    }
                } else {
                    isError = false
                }
            }

            if (isError) {
                // Handle the error, e.g., log it

                props.onError(true)
            } else {
                // Your logic when there is no error

                props.onError(false)

                props.onChange(value)
            }
        } else {
            props.onChange(value)
        }
    }

    const handlePaste = (e) => {
        if (global?.disablePhonePaste) {
            e.preventDefault()
        }
    }

    const handleClick = () => {
        // Get the div element by using a ref
        if (props.onError) {
            const divElement = document.querySelector(
                `.MuiInputBase-root.Mui-error input[name="${props.name}"]`
            )

            // Check if the "Mui-error" class is present
            let isError = false
            if (divElement) {
                if (divElement.parentNode.classList.contains('Mui-error')) {
                    if (props.minChar && props.maxChar) {
                        if (
                            props.value.length > props.minChar &&
                            props.value.length < props.maxChar
                        ) {
                            isError = true
                        } else {
                            isError = false
                        }
                    }
                } else {
                    isError = false
                }
            }

            if (isError) {
                // Handle the error, e.g., log it

                props.onError(true)
            } else {
                // Your logic when there is no error

                props.onError(false)

                props.onChange(props.value)
            }
        } else {
            props.onChange(props.value)
        }
    }

    // When localFormat is true, use a plain TextField with NN NNN NNN formatting
    // and show the country code as a static prefix
    if (props?.localFormat) {
        const configCountryCode =
            allConfigurationVariables && allConfigurationVariables.country_code
                ? allConfigurationVariables.country_code
                : ''

        // If stored value already contains a country code (e.g. "+34 96 732 055"),
        // extract it for the prefix and show only the local part in the input.
        // Otherwise use the config country code as prefix.
        let displayCountryCode = configCountryCode
        let displayValue = props.value || ''
        if (displayValue.startsWith('+')) {
            const match = displayValue.match(/^(\+\d{1,4})\s?(.*)$/)
            if (match) {
                displayCountryCode = match[1]
                displayValue = match[2]
            }
        }

        return (
            <div className="customInput">
                {props.upperLabel ? <label>{props.label}</label> : null}
                <TextField
                    id={props.id}
                    value={displayValue}
                    autoFocus={props.autoFocus}
                    name={props.name}
                    onBlur={props.onBlur}
                    onChange={(e) => {
                        const formatted = formatPhoneLocal(e.target.value)
                        if (props.onError) props.onError(false)
                        props.onChange(formatted)
                    }}
                    InputProps={{
                        inputProps: { id: props.id, maxLength: 10 },
                        startAdornment: displayCountryCode ? (
                            <InputAdornment position="start">
                                <span
                                    style={{
                                        whiteSpace: 'nowrap',
                                        marginRight: 4,
                                    }}
                                >
                                    {displayCountryCode}
                                </span>
                            </InputAdornment>
                        ) : (
                            props.startAdornment
                        ),
                        endAdornment:
                            props.endAdornment === 'info' ? (
                                <InputAdornment position="end">
                                    <Tooltip title={props.tooltiptitle}>
                                        <IconButton>
                                            <span className="material-icons">
                                                info
                                            </span>
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ) : (
                                props.endAdornment
                            ),
                    }}
                    label={props.upperLabel ? null : props.label}
                    size={props.size}
                    disabled={props.disabled}
                    variant={props.variant ? props.variant : 'outlined'}
                    placeholder={props.placeholder || 'NN NNN NNN'}
                    error={props.error}
                    helperText={props.helperText}
                    onPaste={handlePaste}
                    fullWidth
                />
            </div>
        )
    }

    return (
        <div className="customInput">
            <MuiPhoneInput
                defaultCountry="us"
                value={
                    props.value
                        ? props.value.startsWith('+')
                            ? props.value
                            : `+${props.value}`
                        : allConfigurationVariables &&
                          allConfigurationVariables.country_code
                        ? `+${allConfigurationVariables.country_code.replace(
                              '+',
                              ''
                          )}`
                        : '+1'
                }
                autoComplete="off"
                autoFocus={props.autoFocus}
                name={props.name}
                onChange={handleChange}
                InputProps={{
                    inputProps: props.id,
                    startAdornment: props.startAdornment,
                    shrink: shrink,
                }}
                id={props.id}
                label={props.label}
                type={props.type}
                size={props.size}
                onClick={handleClick}
                disabled={props.disabled}
                variant="outlined"
                placeholder={props.placeholder}
                error={props.error}
                helperText={props.helperText}
                countryCodeEditable={props.countryCodeEditable}
                masks={props.masks || {}}
            />
        </div>
    )
}

export default CustomPhone
